module.exports = __webpack_public_path__ + "img/07.94496334.jpg";